'use client'
import React, { ReactElement, ReactNode } from 'react'
import { TextTypes } from '../../../../types'
import { Text } from '../../../atoms'
import { ModalSizes } from '../types/modalTypes'
import { Modal, ModalProps } from '../Modal'

export interface InfoModalProps extends Pick<ModalProps, 'isModalVisible' | 'setModalVisibility' | 'title'> {
    body?: string
    children?: ReactNode
}

export const InfoModal = ({
    children,
    isModalVisible,
    setModalVisibility,
    title,
    body,
}: InfoModalProps): ReactElement => {
    return (
        <Modal
            isModalVisible={isModalVisible}
            setModalVisibility={setModalVisibility}
            canBeClosed={true}
            size={ModalSizes.XS}
            title={title}
        >
            {body && <Text type={TextTypes.SMALL_TEXT}>{body}</Text>}
            {children && children}
        </Modal>
    )
}
